import { useLingui } from "@lingui/react/macro";

import { Skeleton } from "@/shared/ui/skeleton";

const ROWS = 6;

// Заглушка списка, пока идёт первый запрос.
export const MatchListSkeleton = () => {
  const { t } = useLingui();
  return (
    <div role="status" aria-label={t`Loading matches`} className="flex flex-col gap-1.5">
      {Array.from({ length: ROWS }, (_, index) => (
        <Skeleton key={index} className="h-14 w-full rounded-lg" />
      ))}
    </div>
  );
};
